exports = module.exports = require("../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Typist .Cursor {\n  display: inline-block; }\n  .Typist .Cursor--blinking {\n    opacity: 1;\n    animation: blink 1s linear infinite; }\n\n@keyframes blink {\n  0% {\n    opacity: 1; }\n  50% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n", ""]);

